import { createApp } from 'vue'
import App from './App.vue'

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* import specific icons */
import { faArrowDown } from '@fortawesome/free-solid-svg-icons'

/* import specific icons */
import { faArrowUp } from '@fortawesome/free-solid-svg-icons'

library.add(faArrowDown, faArrowUp)

Number.prototype.pad = function(size) {
    var s = String(this);
    while (s.length < (size || 2)) {s = "0" + s;}
    return s;
}

createApp(App).component('font-awesome-icon', FontAwesomeIcon).mount('#app')
